// redux
import { useSelector } from "react-redux";
// mui
import { Box } from "@mui/material";
// components
import StatisticsCard from "../../components/cards/StatisticsCard";
import PageWrapper from "../../components/page/PageWrapper";
import PageTitle from "../../components/page/PageTitle";
// fetching
import fetching from "../../helpers/fetching/fetching";
import { useQuery } from "@tanstack/react-query";
// components
import ThreeDotsLoader from "../../components/loader/ThreeDotsLoader";
import ErrorSection from "../../components/alerts/ErrorSection";
// icons
import { BsBoxSeam } from "react-icons/bs";
import { CiDeliveryTruck } from "react-icons/ci";
import { GoBell } from "react-icons/go";
import { PiMoneyWavyLight } from "react-icons/pi";
import { FaRegUser } from "react-icons/fa6";
// types
import { UserState } from "../../types/types";

const randomDarkColors: string[] = [
  "#F94144",
  "#F3722C",
  "#F8961E",
  "#F9844A",
  "#F9C74F",
  "#90BE6D",
  "#43AA8B",
  "#4D908E",
  "#577590",
  "#277DA1",
];
type Stats = {
  total_orders: number;
  total_users: number;
  total_categories: number;
  total_notifications: number;
};
const Home = () => {
  const userToken = useSelector((state: UserState) => state.user.userToken);
  const fetchStatistics = () => {
    return fetching(`/statistics`, userToken)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) throw data;
        return data;
      });
  };
  const { data, isLoading, isError, error } = useQuery<{ statistics: Stats }>({
    queryKey: ["statistics"],
    queryFn: fetchStatistics,
  });
  return (
    <PageWrapper withBg={false}>
      <PageTitle title="الرئيسية" />
      {isLoading ? (
        <ThreeDotsLoader />
      ) : isError ? (
        <ErrorSection
          errorMsg={error?.message || error.toString() || "Error"}
        />
      ) : (
        <Box
          sx={{
            gap: "12px",
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1,1fr)",
              sm: "repeat(2,1fr)",
              lg: "repeat(3,1fr)",
            },
          }}
        >
          <StatisticsCard
            title="عدد المستخدمين"
            value={data?.statistics.total_users || 0}
            Icon={FaRegUser}
            color={randomDarkColors[0]}
          />
          <StatisticsCard
            title="عدد الفواتير"
            value={data?.statistics.total_orders || 0}
            Icon={CiDeliveryTruck}
            color={randomDarkColors[1]}
          />
          <StatisticsCard
            title="عدد الاشعارات"
            value={data?.statistics.total_notifications || 0}
            Icon={GoBell}
            color={randomDarkColors[4]}
          />
          <StatisticsCard
            title="عدد التصنيفات"
            value={data?.statistics.total_categories || 0}
            Icon={BsBoxSeam}
            color={randomDarkColors[2]}
          />
        </Box>
      )}
    </PageWrapper>
  );
};
export default Home;
